<template>
  <div class="Fankui">
    <div class="container">
      <h2>Feedback</h2>
      <p>ZHUXUE intends to establish an open community for our members, small bits of your feedback, large steps of our growth. Please kindly leave your message below.</p>
      <div class="card">
        <van-row>
          <van-col span="3">
            <div class="imgbox">
              <img src="@/assets/feedback1.png"
                   alt="">
            </div>
          </van-col>
          <van-col span="21">
            <div class="aut">Athena (Malaysia)</div>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <div class="desc">
              “ZHUXUE is a really useful platform for planning your education in China, I successfully applied a Chinese University in Beijing, and my life here is quite nice. People here are friendly and hospitable, you won’t feel isolated here. I enjoy my study and life in China.”
            </div>
          </van-col>
        </van-row>
      </div>
      <div class="card">
        <van-row>
          <van-col span="3">
            <div class="imgbox">
              <img src="@/assets/feedback2.png"
                   alt="">
            </div>
          </van-col>
          <van-col span="21">
            <div class="aut">Hedy (Brunie)</div>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <div class="desc">
              “Study in China is definitely a great choice that you’ll never regret. Thanks to ZHUXUE, I’ve settled in Shanghai for 5 years now, what can always amaze me is that the cashless society in China, which is far more convenient than my life back to my country.”
            </div>
          </van-col>
        </van-row>
      </div>
      <div class="card">
        <van-row>
          <van-col span="3">
            <div class="imgbox">
              <img src="@/assets/feedback3.png"
                   alt="">
            </div>
          </van-col>
          <van-col span="21">
            <div class="aut">Marques (Iran)</div>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <div class="desc">
              “Hello, all. I’m Harris, and I’m from Iran. I am studying MBBS in one of the China Universities in Chongqing. You may have never heard of the city, but I would love to recommend you to come over and have a look. What an amazing place for you guys to study and live, thanks ZHUXUE.”
            </div>
          </van-col>
        </van-row>
      </div>
      <div class="card">
        <van-row>
          <van-col span="3">
            <div class="imgbox">
              <img src="@/assets/feedback4.png"
                   alt="">
            </div>
          </van-col>
          <van-col span="21">
            <div class="aut">Tracy (Thailand)</div>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <div class="desc">
              “Absolutely brilliant study and life experience in Qingdao, wanna come? Join us soon!”
            </div>
          </van-col>
        </van-row>
      </div>
      <div class="card">
        <van-row>
          <van-col span="3">
            <div class="imgbox">
              <img src="@/assets/feedback5.png"
                   alt="">
            </div>
          </van-col>
          <van-col span="21">
            <div class="aut">Leon (Russia)</div>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <div class="desc">
              “Getting bored of studying in your own country? Why not come to China. I’ve been staying here for more than 6 years, and I’ve witnessed the tremendous growth of this country. There are loads of opportunities everywhere not only in big cities like Beijing and Shanghai but also other cities. China is really a big country and has numerous interesting for you to discover. ZHUXUE helped me a lot while I was studying in China, and now I quite adapted and keen to live in China.”
            </div>
          </van-col>
        </van-row>
      </div>
      <div class="card">
        <van-row>
          <van-col span="3">
            <div class="imgbox">
              <img src="@/assets/feedback6.png"
                   alt="">
            </div>
          </van-col>
          <van-col span="21">
            <div class="aut">Louise (Lao)</div>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <div class="desc">
              “My life has been entirely changed since I’ve studied in China. I’ve experienced high tech and well-constructed infrastructure, and I wish I could use what I’ve learned and seen to contribute my own country in the future.”
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
    <div class="form-cont">
      <div class="head">
        Message Feedback
      </div>
      <van-form @submit="onSubmit"
                label-width="5.2em"
                ref="formName">
        <van-field v-model="form.cert_name"
                   name="Your name"
                   label="Your name"
                   placeholder="Your name"
                   :required="true"
                   :rules="[{ required: true, message: 'Please input your name' }]" />
        <van-field v-model="form.phone"
                   name="Phone"
                   label="Phone"
                   placeholder="Phone"
                   :required="true"
                   :rules="[{ required: true, message: 'Please input your phone number' }]" />
        <van-field v-model="form.country"
                   name="Country"
                   label="Country"
                   placeholder="Country"
                   :required="true"
                   :rules="[{ required: true, message: 'Please input your country' }]" />

        <van-field v-model="form.content"
                   name="Message"
                   label="Message"
                   placeholder="Message"
                   type="textarea"
                   maxlength="150" />
        <van-button block
                    type="info"
                    native-type="submit">Submit</van-button>
      </van-form>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axiosApi from "../api/api.js";
import { Toast } from 'vant';

export default {
  name: 'Faq',
  components: {
  },
  data () {
    return {
      form: {
        cert_name: '',
        phone: '',
        country: '',
        content: '',
      },
    }
  },
  methods: {
    onSubmit () {
      axiosApi('message', {
        form_type: 1,
        content: this.formTit,
        ...this.form
      }, 'post').then(res => {
        if (res.data.status) {
          Toast.success('Success');
          this.showForm = false
          this.form = {
            name: '',
            phone: '',
            email: '',
          }
        } else {
          Toast.fail('Error, please try again');
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  h2 {
    text-align: center;
    color: #263e65;
  }
  h4 {
    margin: 0;
  }
  font-size: 28px;
  p {
    margin-bottom: 20px;
    text-indent: 2em;
  }
  .tips {
    color: #f29810;
    margin: 10px 0;
  }
  .tips_p {
    color: #545454;
  }
  .tips_lis {
    margin-top: 10px;
    color: #545454;
  }
  .tit1 {
    font-size: 32px;
    font-weight: bold;
    color: #f29810;
    text-align: center;
    margin-bottom: 20px;
  }
  .buzhu {
    h3 {
      margin-bottom: 20px;
      color: #263e65;
    }
    .lis {
      padding: 20px;
      box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: 0.2);
    }
  }
  .shenqingTit {
    border-left: 10px solid #263e65;
    line-height: 1;
    font-size: 32px;
    margin: 30px 0;
    padding-left: 10px;
  }
}
[class*="van-hairline"]::after {
  border: none;
}
.cont-card {
  padding: 20px 0;
}

.cont-card ::v-deep {
  .van-collapse-item__content {
    background-color: #f7f8fa;
  }
}
.Fankui {
  background-color: #edf8fe;
  height: 100%;
  overflow: auto;
}
.card {
  margin-top: 40px;
  box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: 0.2);
  border-radius: 15px;
  padding: 20px;
  background-color: #fff;
  .imgbox {
    height: 100px;
  }
  .aut {
    display: flex;
    padding-left: 20px;
    height: 100px;
    align-items: center;
    font-weight: bold;
  }
  .desc {
    margin-top: 30px;
  }
}

.form-cont {
  padding: 20px;
  background-color: #174166;
  color: #fff;
  .head {
    font-size: 36px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .van-cell {
    margin-bottom: 20px;
    border-radius: 15px;
  }
  .van-button--normal {
    border-radius: 15px;
  }
}
</style>
<style lang="scss">
.van-step--finish .van-step__circle,
.van-step--finish .van-step__line {
  background-color: #263e65;
}
.faq-detail {
  color: #464646;
}
</style>
